import React, { useState, use, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { ApiContext } from "../Context/Context";
import { Link } from "react-router-dom";

import LoginDialog from "./LoginDialog";

import {
  BaseUrl,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../Services/Urls";
import { useNavigate } from "react-router-dom";
import FilterParams from "../Classes/FilterParams";

function Footer() {
  const navigate = useNavigate();
  return (
    <>
      <>
        {/* Footer Section Start */}
        <footer className="footer-wrap style2 pt-100">
          <img
            src="assets/img/footer-map.png"
            alt="Image"
            className="footer-shape-one"
          />
          <div className="footer-top">
            <div className="container">
              <div className="row pb-75">
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 pe-xl-5">
                  <div className="footer-widget">
                    <Link to="/" className="footer-logo">
                      <img src="assets/img/lp-logo.svg" alt="Image" />
                    </Link>
                    <p className="comp-desc">
                      Your trusted partner in finding the perfect property.
                      Connecting buyers, sellers, and renters across India.
                    </p>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h3 className="footer-widget-title">Properties</h3>
                    <ul className="footer-menu list-style">
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 1,
                            featured: null,
                             status : 2
                          });

                          navigate("/view-all-listing?tabID=384", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <Link>
                          <i className="ri-arrow-right-s-line" />
                          Buy Properties
                        </Link>
                      </li>
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 2,
                            featured: null,
                             status : 2
                          });

                          navigate("/view-all-listing?tabID=385", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <Link>
                          <i className="ri-arrow-right-s-line" />
                          Rent Properties
                        </Link>
                      </li>
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 2,
                            vertical: 1,
                            featured: null,
                             status : 2
                          });

                          navigate("/view-all-listing?tabID=387", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <Link>
                          <i className="ri-arrow-right-s-line" />
                          Commercial
                        </Link>
                      </li>
                      <li
                        onClick={(e) => {
                          e.preventDefault();
                          const filters = new FilterParams({
                            propertyType: 1,
                            vertical: 3,
                            featured: null,
                             status : 2
                          });

                          navigate("/view-all-listing?tabID=386", {
                            state: {
                              filters: filters,
                            },
                          });
                        }}
                      >
                        <Link>
                          <i className="ri-arrow-right-s-line" />
                          PG & Co-living
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 ps-xl-5">
                  <div className="footer-widget">
                    <h3 className="footer-widget-title">Services</h3>
                    <ul className="footer-menu list-style">
                      <li>
                        <Link to="#" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Home Loans
                        </Link>
                      </li>
                      <li>
                        <Link to="#" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Agent Finder
                        </Link>
                      </li>
                      <li>
                        <Link to="#" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Interior Design
                        </Link>
                      </li>
                      <li>
                        <Link to="#" target="_blank">
                          <i className="ri-arrow-right-s-line" />
                          Packers & Movers
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div> */}
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h3 className="footer-widget-title">Company</h3>
                    <ul className="footer-menu list-style">
                      <li>
                        <Link to="/about-us" target="">
                          <i className="ri-arrow-right-s-line" />
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/contactus" target="">
                          <i className="ri-arrow-right-s-line" />
                          Contact
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy" target="">
                          <i className="ri-arrow-right-s-line" />
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-and-conditions" target="">
                          <i className="ri-arrow-right-s-line" />
                          Terms of Service
                        </Link>
                      </li>
                      <li>
                        <Link to="/news" target="">
                          <i className="ri-arrow-right-s-line" />
                          News & Articles
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="footer-bottom">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <p className="copyright-text">
                    <i className="ri-copyright-line" />
                    All Rights Reserved By{" "}
                    <Link to="#" target="_blank">
                      Landpanda
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* Footer Section End */}
      </>
    </>
  );
}

export default Footer;
